import React, { useEffect } from 'react';

const TypeformQuiz = (): JSX.Element => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      data-tf-widget="IlKvWIYA"
      data-tf-iframe-props='title="What&apos;s My Decor Style?" Quiz'
      data-tf-medium="snippet"
      data-tf-disable-auto-focus="true"
      style={{ width: '100%', height: '400px' }}
    />
  );
};

export default TypeformQuiz;
